import { render, staticRenderFns } from "./myCounselReport.vue?vue&type=template&id=4605e63f&"
import script from "./myCounselReport.vue?vue&type=script&lang=js&"
export * from "./myCounselReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports